import { useState } from "react";
import { Button, Container, Input, Stack, Typography, Box } from "@mui/material";

import { logAnalyticsEvent } from 'lib/firebase/analytics';
import Layout from "lib/components/Layout";

import { base } from 'themes';
import { Logo } from 'components/icons';
import { FOOTER_PROPS } from 'constants';

import { convertToCSV, parseList, detectPlatform } from "./utils";

import { MOXFIELD, TCGPLAYER, DELVERSCAN } from "./constants";

export default function Parser() {
  const [rawText, setRawText] = useState("");
  const [detectedPlatform, setDetectedPlatform] = useState(null);
  const [outputs, setOutputs] = useState({});

  const handleInputChange = (event) => {
    const text = event.target.value;
    setRawText(text);

    if (text.trim()) {
      const platform = detectPlatform(text);
      setDetectedPlatform(platform);

      if (platform) {
        const parsed = parseList(text, platform);
        const newOutputs = {};

        // Generar salida para todas las plataformas
        [MOXFIELD, TCGPLAYER, DELVERSCAN].forEach(targetPlatform => {
          newOutputs[targetPlatform] = convertToCSV(parsed, targetPlatform);
        });

        setOutputs(newOutputs);
      }
    } else {
      setDetectedPlatform(null);
      setOutputs({});
    }
  }

  return (
    <Layout
      theme={base}
      footerProps={FOOTER_PROPS}
      navbarProps={{
        logo: (<Logo />),
        right: (
          <Button
            href="https://szk4u.mjt.lu/wgt/szk4u/xu59/form?c=0799e44b"
            target="_blank"
            variant="contained"
            onClick={() => logAnalyticsEvent('click', { label: 'Try TCGist' })}
          >
            Try TCGist
          </Button>
        )
      }}
    >
      <Container sx={{ pt: 15, height: "100vh" }}>
        {detectedPlatform && (
          <Typography variant="h6" sx={{ mb: 2 }}>
            Detected Platform: {detectedPlatform}
          </Typography>
        )}

        <Input
          aria-label="List input"
          disableUnderline={true}
          maxRows={20}
          minRows={15}
          multiline
          placeholder="Paste your list here..."
          onChange={handleInputChange}
          value={rawText}
          sx={{ mb: 2 }}
        />

        {Object.keys(outputs).length > 0 && (
          <Stack spacing={2}>
            {[MOXFIELD, TCGPLAYER, DELVERSCAN].map(platform => (
              <Box key={platform}>
                <Typography variant="subtitle1" sx={{ mb: 1 }}>
                  {platform} Format:
                </Typography>
                <Input
                  aria-label={`${platform} output`}
                  disableUnderline={true}
                  maxRows={20}
                  minRows={5}
                  multiline
                  value={outputs[platform] || ""}
                  readOnly
                />
              </Box>
            ))}
          </Stack>
        )}
      </Container>
    </Layout>
  );
};
